(function () {

  // Mobile menu
  const menuTrigger = document.querySelector('.menu--navigation-menu-trigger');
  if (menuTrigger) {
    menuTrigger.addEventListener('click', () => {
      document.body.classList.toggle('menu--navigation-menu-open');
      menuTrigger.classList.toggle('menu--navigation-menu-trigger-open');
    });
  }

  // Search wrapper close button
  const searchWrapper = document.querySelector('.search-wrapper');
  if (searchWrapper) {
    const closeButton = document.createElement('a');
    closeButton.className = 'menu-close';
    closeButton.href = '#';
    closeButton.textContent = 'Close';
    searchWrapper.prepend(closeButton);
  }

  // Menu navigation handlers
  const menuLevel0Links = document.querySelectorAll('.menu-level-0 > .menu-item > a');
  const menuClose = document.querySelector('.menu-close');

  if (menuClose && menuLevel0Links.length > 0) {
    [...menuLevel0Links, menuClose].forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const menuItem = link.parentElement;

        menuLevel0Links.forEach(otherLink => {
          if (otherLink !== link) {
            otherLink.parentElement.classList.remove('menu-dropdown-expanded');
          }
        });

        if (link !== menuClose) {
          menuItem.classList.toggle('menu-dropdown-expanded');
        }

        const hasExpandedDropdown = document.querySelector('.menu-dropdown-expanded');
        if (hasExpandedDropdown) {
          menuClose.classList.add('menu-close-visible');
          document.body.classList.add('menu--navigation-menu-open');
        } else {
          document.body.classList.remove('menu--navigation-menu-open');
          menuClose.classList.remove('menu-close-visible');
        }

        // Refresh slick carousel if present (vanilla JS approach)
        const carousel = document.querySelector('.l-events-carousel');
        if (carousel) {
          // Check if the carousel has a slick instance
          if (carousel.slick && typeof carousel.slick.refresh === 'function') {
            carousel.slick.refresh();
          }
          // Alternative approach using a method call pattern similar to jQuery
          else if (carousel.slick && typeof carousel.slick === 'object') {
            try {
              // This emulates the jQuery slick('refresh') pattern
              const refreshMethod = carousel.slick['refresh'];
              if (typeof refreshMethod === 'function') {
                refreshMethod.call(carousel.slick);
              }
            } catch (e) {
              console.warn('Could not refresh slick carousel', e);
            }
          }
        }

        // Remove contextual region class
        document.querySelectorAll('.menu-dropdown').forEach(dropdown => {
          dropdown.classList.remove('contextual-region');
        });
      });
    });
  }

  // Menu level 1 interactions
  document.querySelectorAll('.menu-level-1 > .menu-item:not(:nth-child(3)) > a, .menu-item--research .menu-level-1 > .menu-item > a, .menu-item--resource .menu-level-1 > .menu-item > a')
    .forEach(link => {
      ['mouseenter', 'mouseleave', 'touchstart'].forEach(eventType => {
        link.addEventListener(eventType, (e) => {
          e.preventDefault();

          // Remove expanded state from other items
          document.querySelectorAll('.menu-level-1 > .menu-item > a').forEach(otherLink => {
            if (otherLink !== link) {
              otherLink.classList.remove('menu-link-expanded');
              const dropdown = otherLink.parentElement.querySelector('.menu-dropdown-1');
              if (dropdown) dropdown.classList.remove('menu-level-expanded');
            }
          });

          // Add expanded state to current item
          link.classList.add('menu-link-expanded');
          const dropdown = link.parentElement.querySelector('.menu-dropdown-1');
          if (dropdown) dropdown.classList.add('menu-level-expanded');
        });
      });
    });

  // Menu level 2 interactions
  document.querySelectorAll('.menu-level-2 > .menu-item:not(:nth-child(2)) > a')
    .forEach(link => {
      ['mouseenter', 'mouseleave', 'touchstart'].forEach(eventType => {
        link.addEventListener(eventType, (e) => {
          e.preventDefault();

          document.querySelectorAll('.menu-level-2 > .menu-item > a').forEach(otherLink => {
            if (otherLink !== link) {
              otherLink.classList.remove('menu-link-expanded');
              const dropdown = otherLink.parentElement.querySelector('.menu-dropdown-2');
              if (dropdown) dropdown.classList.remove('menu-level-expanded');
            }
          });

          link.classList.add('menu-link-expanded');
          const dropdown = link.parentElement.querySelector('.menu-dropdown-2');
          if (dropdown) dropdown.classList.add('menu-level-expanded');
        });
      });
    });

  // Back link handler
  document.querySelectorAll('.menu--navigation-menu-back-link').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const menuItem = this.closest('.menu-item--expanded');
      if (menuItem) menuItem.classList.remove('menu-dropdown-expanded');

      const menuDropdown = this.closest('.menu-dropdown');
      if (menuDropdown) menuDropdown.classList.remove('menu-level-expanded');
    });
  });

  // Add class to menu items with spans
  document.querySelectorAll('.menu-item span').forEach(span => {
    span.parentElement.classList.add('contains-span');
  });

})();
